import { Splide } from '@splidejs/splide';

// Drupal behavior for the Partner Slider block
(function (Drupal) {
  Drupal.behaviors.imageCarrousel = {
    attach(context: HTMLElement) {
      context.querySelectorAll<HTMLElement>('[data-image-carrousel-slider]').forEach((el) => {
        if (el.classList.contains('is-initialized')) return;

        const slides = el.querySelectorAll('.splide__slide');
        const slideCount = slides.length;

        const sliderEnabled = slideCount > 5;
        const showArrows = slideCount > 5;

        new Splide(el, {
          type: sliderEnabled ? 'loop' : 'slide',
          perPage: 6,
          perMove: 1,
          clones: sliderEnabled ? undefined : 0, // prevent clone creation
          autoplay: false,
          interval: 3000,
          gap: '30px',
          pagination: false,
          arrows: showArrows ? true : false,
          breakpoints: {
            1400: {
              perPage: 5,
              type: 'loop',
              arrows: 'true'
            },
            1200: {
              perPage: 4,
              type: 'loop',
              arrows: 'true'
            },
            992: {
              perPage: 3,
              type: 'loop',
              arrows: 'true'
            },
            768: {
              perPage: 2,
              type: 'loop',
              arrows: 'true'
            },
            576: {
              perPage: 1,
              type: 'loop',
              arrows: 'true'
            }
          }
        }).mount();

        if(!sliderEnabled) {
          const splideList = el.querySelector('.splide__list');
          if(splideList) {
            splideList.classList.add('justify-center');
          }
        }
        el.classList.add('is-initialized');
      });
    },
  };
})(Drupal as any);
